import { progressBarSchema } from "@redotech/redo-model/checkouts/checkout-optimization-settings";
import * as z from "zod";

export const updateStorefrontProgressBarSettings = {
  name: "updateStorefrontProgressBarSettings" as const,
  input: z.object({ settings: progressBarSchema.optional() }),
  output: z.null(),
};
